var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-empty',{attrs:{"description":"免密提现申请已提交，请稍后在店铺管理查询结果"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }